module.exports = __WEBPACK_EXTERNAL_MODULE_8__;


//////////////////
// WEBPACK FOOTER
// external "@angular/platform-browser"
// module id = 8
// module chunks = 0